import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import UserApplicationRoleModel from '../../../models/UserApplicationRoleModel';
import DataService from "../../../services/data.service";
import { UserProps } from '../../../types/IdProps';
import AddApplicationRolePopup from '../Popups/User_popup_AddApplicationRole';

const User_tab_ApplicationRoles: React.FC<UserProps> = ({ userId }) => {
    const [data, setData] = useState<UserApplicationRoleModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [userId]);

    function getTableData() {
        DataService.get<UserApplicationRoleModel[]>('api/v1/UserApplicationRoles/ByUser/' + userId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/UserApplicationRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'applicationRoleId', visible: false },
        { title: 'Role', dataProp: 'applicationRole.name', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditApplicationRoleForUser)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtUserApplicationroles'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Applicationrole'
                navigateUrl='/plm/UserManagement/ApplicationRole/'
            />
            <AddApplicationRolePopup userId={userId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />

        </>
    );
}
export default User_tab_ApplicationRoles;